import React, { LazyExoticComponent } from 'react';

import { UserRoleDto } from '@/api/generated';

import { RouteStateModel } from './RouteState.model.ts';

export enum RouteEnum {
  ANALYSIS_REMARKS = '/analysis-remarks',
  CANDIDATE_DETAILS = '/processes/:processId/candidates/:candidateApplicationId',
  CV_SEARCH = '/cv-search',
  CV_SEARCH_CREATE = '/cv-search/new',
  CV_SEARCH_CREATE_ALIAS = '/cv-search/create',
  EXPERIENCE_COMPANIES = '/experience-companies',
  FORBIDDEN = '/forbidden',
  INTAKE_CALL_TEMPLATES = '/intake-call-templates',
  INTERVIEW_SIMULATION = '/processes/:processId/candidates/:candidateApplicationId/interview-simulation/:interviewSimulationId',
  LOGIN_ELIVION = '/login/elivion',
  LOGIN_SUCCESSFUL = '/login-successful',
  MEETING_DETAILS = '/meetings/:meetingId',
  MEETINGS = '/meetings',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = '/not-found',
  PROCESS_CV_SEARCH_DETAILS = '/cv-search/:cvSearchId',
  PROCESS_DETAILS = '/processes/:processId',
  PROCESS_TEMPLATES = '/process-templates',
  PROCESSES = '/processes',
  ROOT = '/',
  STATISTICS = '/statistics',
  TAGS = '/tags',
}

export interface RouteModel {
  addons?:
    | LazyExoticComponent<React.FC<{ route: RouteStateModel }>>
    | React.FC<{ route: RouteStateModel }>;
  component:
    | LazyExoticComponent<React.FC<{ route: RouteStateModel }>>
    | React.FC<{ route: RouteStateModel }>;
  path: RouteEnum;
  roles?: UserRoleDto[];
}
